import { Plus, Trash2 } from "lucide-react";

const inputCls = "w-full bg-[#1A1A1A] border border-[#262626] px-4 py-2.5 text-white font-['Outfit'] text-sm placeholder:text-white/25 focus:outline-none focus:border-[#C5A059]/50 transition-colors";

export default function FaqBuilder({ items, onChange }) {
  const add = () => onChange([...items, { question: "", answer: "", _key: `f-${Date.now()}-${Math.random().toString(36).slice(2, 8)}` }]);
  const remove = (i) => onChange(items.filter((_, idx) => idx !== i));
  const update = (i, field, value) => {
    const next = [...items];
    next[i] = { ...next[i], [field]: value };
    onChange(next);
  };

  return (
    <div className="space-y-3">
      {items.map((item, i) => (
        <div key={item._key || `legacy-${i}`} className="border border-[#262626] p-4 space-y-2">
          <div className="flex justify-between items-center">
            <span className="text-white/30 text-[11px] font-['Outfit'] uppercase tracking-wider">Fråga {i + 1}</span>
            <button type="button" onClick={() => remove(i)} className="text-white/20 hover:text-red-400 transition-colors">
              <Trash2 size={14} />
            </button>
          </div>
          <input value={item.question} onChange={e => update(i, "question", e.target.value)} placeholder="t.ex. Vad ingår i VIP-paketet?" className={inputCls} />
          <textarea value={item.answer} onChange={e => update(i, "answer", e.target.value)} placeholder="Svaret..." rows={2} className={`${inputCls} resize-none`} />
        </div>
      ))}
      <button type="button" onClick={add} className="text-[#C5A059]/60 hover:text-[#C5A059] text-xs font-['Outfit'] flex items-center gap-1 mt-1 transition-colors">
        <Plus size={12} /> Lägg till fråga
      </button>
    </div>
  );
}
